import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export interface MainFiltersInterface {
  programId: number;
  schoolId: number;
  academicYearId: number;
  academicSemesterId: number;
  educationalProgramId?: number;
}

@Injectable({
  providedIn: 'root'
})
export class MainFiltersService {
  private subject = new Subject<MainFiltersInterface>();
  globalFilterObj: MainFiltersInterface = {
    programId: 0,
    educationalProgramId: null,
    schoolId: 0,
    academicYearId: 0,
    academicSemesterId: 0
  };

  constructor() {}

  sendMainFilter(filter: MainFiltersInterface) {
    this.globalFilterObj = {
      programId: filter.programId,
      schoolId: filter.schoolId,
      academicYearId: filter.academicYearId,
      academicSemesterId: filter.academicSemesterId,
      educationalProgramId: filter.educationalProgramId
    };
    if (
      this.globalFilterObj.programId > 0 &&
      this.globalFilterObj.schoolId > 0 &&
      this.globalFilterObj.educationalProgramId > 0 &&
      this.globalFilterObj.academicYearId > 0
    ) {
      this.subject.next(this.globalFilterObj);
    }
  }

  clearMainFilter() {
    this.subject.next();
  }
  deleteMainFilter() {
    this.globalFilterObj = {
      programId: null,
      schoolId: null,
      academicYearId: null,
      academicSemesterId: null,
      educationalProgramId: null
    };
    this.subject.next();
  }

  getMainFilter(): Observable<MainFiltersInterface> {
    return this.subject.asObservable();
  }
}
